<template>
  <div class="w-100" style="padding-right: 15px; padding-left: 15px;">
    <b-row>
      <b-col sm="12" md="12" lg="12" xl="12">
        <b-form-group
          label="Identificação responsável setor"
          label-for="responsavelSetor"
          label-class="float-left"
        >
          <info-icon
            v-b-tooltip.hover.right="
              'Informe o nome do responsável pela realização da entrega/retirada dos materiais'
            "
            class="tooltip-icon"
          />
          <b-form-input
            name="responsavelSetor"
            v-model="responsavel_setor"
            @input="(v) => $emit('updateModel', { responsavel_setor: v })"
            class="invision-input input-icon"
            :disabled="isBusy"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('responsavelSetor')"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ResponsavelSetor',
  inject: ['validator', 'validateState'],
  created() {
    this.$validator = this.validator;
  },

  data() {
    return {
      responsavel_setor: '',
    };
  },

  props: {
    isBusy: {
      type: Boolean,
    },
    options: {
      type: Object,
      required: false,
    },
  },
};
</script>
